import { Whitelist } from "../types";
import { State, Action, ActionType } from "../types/redux";

export const initialState: State = {
  splashModal: {
    isOpen: false
  },
  featurePreviewModal: {
    isOpen: false
  },
  content: {},
  whitelist: []
};

const reducer = (state = initialState, action: Action): State => {
  switch (action.type) {
    case ActionType.OPEN_SPLASH: {
      return {
        ...state,
        splashModal: {
          ...state.splashModal,
          isOpen: true
        }
      };
    }
    case ActionType.CLOSE_SPLASH: {
      return {
        ...state,
        splashModal: {
          ...state.splashModal,
          isOpen: false
        }
      };
    }
    case ActionType.OPEN_FEATURES_PREVIEW: {
      return {
        ...state,
        featurePreviewModal: {
          ...state.featurePreviewModal,
          isOpen: true
        }
      };
    }
    case ActionType.CLOSE_FEATURES_PREVIEW: {
      return {
        ...state,
        featurePreviewModal: {
          ...state.featurePreviewModal,
          isOpen: false
        }
      };
    }
    case ActionType.SET_CONTENT: {
      return {
        ...state,
        content: {
          ...state.content,
          ...action.payload
        }
      };
    }
    case ActionType.SET_WHITELIST: {
      return {
        ...state,
        whitelist: action.payload as Whitelist[]
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
